import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import accounting from "accounting";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import { TranslationContext } from "../../../../Providers/TranslationProvider";

moment.locale("NL");

const Cell = styled.div`
    width: ${props => `${100 / props.amount}%`};
    @media (min-width: 540px) {
        width: ${props => `${85 / props.amount}%`};
    }
`;

const PriceTable = ({ headerItems, bodyItems, type }) => {
    const {
        onSelectPriceAndVariation,
        onCustomQtyPrice,
        customPrices,
        customPricesLoading,
        customPricesError,
        setCustomPrices
    } = useContext(ProductOptionStepsContext);
    const { trans } = useContext(TranslationContext);

    const [customQty, setCustomQty] = useState("");
    const [customQtyInvalid, setCustomQtyInvalid] = useState(false);

    useEffect(() => {
        if (customQty > 5000 || customQty < 25) {
            setCustomQtyInvalid(true);
        } else {
            setCustomPrices(false);
            setCustomQtyInvalid(false);
        }
    }, [customQty]);

    return (
        <>
            <div className="mb-4">
                <div className="flex -mx-2 mb-4">
                    <div
                        style={{ width: "15%" }}
                        className={`px-2 flex-grow flex items-center justify-center font-bold hidden sm:block`}
                    >
                        Oplage
                    </div>
                    {headerItems.map(item => (
                        <Cell
                            key={item.id}
                            amount={headerItems.length}
                            className={`px-2 flex flex-col items-center`}
                        >
                            <Label type={item.label} />
                            <span className="text-sm text-center">
                                Verwachte levering:
                            </span>
                            <span className="text-xs text-center">
                                {moment(item.leveren, "DD-MM-YYYY").format(
                                    "dddd"
                                )}
                            </span>
                            <b className="mb-2 text-center">
                                {moment(item.leveren, "DD-MM-YYYY").format(
                                    "DD MMMM"
                                )}
                            </b>
                            <span className="text-xs text-center text-gray-600 w-full">
                                {trans("complete_order_deliver_files", true)}:{" "}
                                {moment(
                                    item.deadline,
                                    "DD-MM-YYYY HH:mm"
                                ).format("dddd DD MMMM")}{" "}
                                ({trans("before", false)}{" "}
                                {item.deadline.split(" ")[1]})
                            </span>
                        </Cell>
                    ))}
                </div>

                {bodyItems.map(item => (
                    <div
                        key={item.qty}
                        className="flex flex-wrap"
                    >
                        <div
                            style={{ width: "15%" }}
                            className={`items-center justify-center border-r-2 border-t-2  border-gray-300 hidden sm:flex`}
                        >
                            {item.qty}
                        </div>
                        <div
                            className={`w-full font-bold sm:hidden text-center text-blue-400 mb-1`}
                        >
                            Oplage: {item.qty}
                        </div>
                        {item.options.map(option => (
                            <Cell
                                amount={headerItems.length}
                                onClick={() =>
                                    onSelectPriceAndVariation(
                                        type,
                                        option.delivery,
                                        option.variation_id,
                                        item.qty,
                                        option.product_id
                                    )
                                }
                                className={`mb-2 sm:mb-0 border-r-2 border-t-2 last:border-r-0 border-gray-300 flex flex-col items-center p-2
                                    cursor-pointer hover:bg-yellow-100 hover:text-yellow-900
                                    ${option.selected &&
                                        `bg-yellow-100 text-yellow-900`}
                                `}
                                key={
                                    option.variation_id +
                                    option.delivery +
                                    option.price_in
                                }
                            >
                                {option.price_discount ? (
                                    <>
                                        <del>
                                            <b>
                                                {accounting.formatMoney(
                                                    option.price_ex,
                                                    "€",
                                                    2,
                                                    ".",
                                                    ","
                                                )}
                                            </b>{" "}
                                            <br className="block lg:hidden" />
                                            <small>(ex. BTW)</small>
                                        </del>
                                        <span>
                                            <b>
                                                {accounting.formatMoney(
                                                    option.price_discount,
                                                    "€",
                                                    2,
                                                    ".",
                                                    ","
                                                )}
                                            </b>{" "}
                                            <br className="block lg:hidden" />
                                            <small>(ex. BTW)</small>{" "}
                                        </span>
                                        <span>
                                            <b>
                                                {accounting.formatMoney(
                                                    option.price_in,
                                                    "€",
                                                    2,
                                                    ".",
                                                    ","
                                                )}
                                            </b>{" "}
                                            <br className="block lg:hidden" />
                                            <small>(incl. BTW)</small>
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            {" "}
                                            <b>
                                                {accounting.formatMoney(
                                                    option.price_ex,
                                                    "€",
                                                    2,
                                                    ".",
                                                    ","
                                                )}
                                            </b>{" "}
                                            <br className="block lg:hidden" />
                                            <small>(ex. BTW)</small>{" "}
                                        </span>
                                        <span>
                                            <b>
                                                {accounting.formatMoney(
                                                    option.price_in,
                                                    "€",
                                                    2,
                                                    ".",
                                                    ","
                                                )}
                                            </b>{" "}
                                            <br className="block lg:hidden" />
                                            <small>(incl. BTW)</small>{" "}
                                        </span>
                                    </>
                                )}
                            </Cell>
                        ))}
                    </div>
                ))}
            </div>

            {type === "print" &&
                (bodyItems[0].options[0].product_id === 1 ||
                    bodyItems[0].options[0].product_id === 5) && (
                    <div className="w-full p-4 border border-gray-300 rounded">
                        <h6 className="font-bold mb-2">
                            Afwijkende printoplage
                        </h6>
                        <div className="mb-4">
                            <label className="block mb-1" htmlFor="">
                                Oplage
                            </label>
                            <input
                                className="bg-gray-200 h-10 p-2 mr-2"
                                type="number"
                                onChange={e => setCustomQty(e.target.value)}
                            />
                            <button
                                onClick={() =>
                                    onCustomQtyPrice(
                                        bodyItems[0].options[0].variation_id,
                                        customQty
                                    )
                                }
                                className="bg-yellow-200 text-yellow-900 h-10 px-4 text-white rounded mr-2 font-bold hover:bg-yellow-400"
                            >
                                Berekenen
                            </button>
                        </div>
                        {customPricesLoading && (
                            <div className="w-full">
                                Prijzen aan het ophalen...
                            </div>
                        )}
                        {customPricesError && (
                            <div className="w-full">
                                Er is iets misgegaan, neem contact op met
                                24drukwerk
                            </div>
                        )}
                        {customPrices && (
                            <div className="w-full">
                                {customQtyInvalid && (
                                    <div>
                                        Dit is geen geldige oplage voor digitaal
                                        drukwerk. Vul een oplage in tussen 25 en
                                        5000 en klik op Berekenen.
                                    </div>
                                )}
                                {!customQtyInvalid && (
                                    <>
                                        <div className="flex -mx-2 mb-4">
                                            <div
                                                style={{ width: "15%" }}
                                                className={`px-2 flex-grow`}
                                            >
                                                Oplage
                                            </div>
                                            {Object.entries(customPrices).map(
                                                ([key, value]) => (
                                                    <Cell
                                                        key={key}
                                                        amount={
                                                            Object.entries(
                                                                customPrices
                                                            ).length
                                                        }
                                                        className={`px-2 flex flex-col items-center`}
                                                    >
                                                        {key === "1" && (
                                                            <Label
                                                                type={
                                                                    "3 werkdagen"
                                                                }
                                                            />
                                                        )}
                                                        {key === "2" && (
                                                            <Label
                                                                type={"24 uur"}
                                                            />
                                                        )}
                                                        {key === "9" && (
                                                            <Label
                                                                type={
                                                                    "Spoed levering"
                                                                }
                                                            />
                                                        )}
                                                    </Cell>
                                                )
                                            )}
                                        </div>
                                        <div className="flex -mx-2 mb-4">
                                            <div
                                                style={{ width: "15%" }}
                                                className={`flex p-2 items-center border-r-2  border-gray-300 `}
                                            >
                                                {customQty}
                                            </div>
                                            {Object.entries(customPrices).map(
                                                ([key, value]) => (
                                                    <Cell
                                                        key={key}
                                                        amount={
                                                            Object.entries(
                                                                customPrices
                                                            ).length
                                                        }
                                                        onClick={() =>
                                                            onSelectPriceAndVariation(
                                                                type,
                                                                key,
                                                                bodyItems[0]
                                                                    .options[0]
                                                                    .variation_id,
                                                                customQty,
                                                                bodyItems[0]
                                                                    .options[0]
                                                                    .product_id,
                                                                value
                                                            )
                                                        }
                                                        className={`border-r-2 last:border-r-0 border-gray-300 flex flex-col items-center p-2 cursor-pointer hover:bg-yellow-100 hover:text-yellow-900`}
                                                    >
                                                        {accounting.formatMoney(
                                                            value,
                                                            "€",
                                                            2,
                                                            ".",
                                                            ","
                                                        )}{" "}
                                                        <small>(ex. BTW)</small>
                                                    </Cell>
                                                )
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                )}
        </>
    );
};

export default PriceTable;

const Label = ({ type }) => {
    const { trans } = useContext(TranslationContext);

    switch (type) {
        case "3 werkdagen":
            return (
                <span className="rounded-lg bg-gray-200 text-gray-900 px-1 lg:px-2 text-xs lg:text-sm border border-gray-400 mb-2 text-center">
                    {type}
                </span>
            );
        case "24 uur":
            return (
                <span className="rounded-lg bg-green-100 text-green-900 px-1 lg:px-2  text-xs lg:text-sm border border-green-300 mb-2 text-center">
                    {type}
                </span>
            );
        case "Spoed levering":
            return (
                <span className="rounded-lg bg-red-100 text-red-900 px-1 lg:px-2  text-xs lg:text-sm border border-red-300  mb-2 text-center">
                    Spoed (NL)
                </span>
            );
        case "5 werkdagen":
            return (
                <span className="rounded-lg bg-gray-200 text-gray-900 px-1 lg:px-2  text-xs lg:text-sm border border-gray-400  mb-2 text-center">
                    {type}
                </span>
            );
        default:
            return (
                <span className="rounded-lg bg-gray-200 text-gray-900 px-1 lg:px-2 text-xs lg:text-sm border border-gray-400  mb-2 text-center">
                    {type}
                </span>
            );
    }
};
